export default {
  apiKey: "AIzaSyAqwcFPilYLIrVIu1-BprkC08hOAhWQikg",
  authDomain: "ggapp-d2bae.firebaseapp.com",
  databaseURL: "https://ggapp-d2bae-default-rtdb.firebaseio.com",
  projectId: "ggapp-d2bae",
  storageBucket: "ggapp-d2bae.appspot.com",
  messagingSenderId: "614262062561",
  appId: "1:614262062561:web:4def07426bd52832e8a6a0"
};

// Separate config for the foodie database
export const foodieConfig = {
  apiKey: "AIzaSyAqwcFPilYLIrVIu1-BprkC08hOAhWQikg",
  authDomain: "ggapp-d2bae.firebaseapp.com",
  databaseURL: "https://ggapp-foodies.firebaseio.com",
  projectId: "ggapp-d2bae",
  storageBucket: "ggapp-d2bae.appspot.com",
  messagingSenderId: "614262062561",
  appId: "1:614262062561:web:4def07426bd52832e8a6a0"
};
